/**
 * Created by Victor Rojo on 7/6/19.
 */
import {Component, Input, Output, EventEmitter, OnDestroy} from '@angular/core';

import { BsDatepickerConfig, BsDatepickerViewMode } from 'ngx-bootstrap/datepicker';

import {PumpWidget} from "../../widget/Widget";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";
import {WidgetStatusChangeAware} from "../base-widget/WidgetStatusChangeAware";
import {Pump} from "../../ipetrol/Pump";


@Component({
  selector: 'cnxn-datetime-picker',
  templateUrl: './DateTimePicker.component.html',
  styleUrls: ['./DateTimePicker.component.css']
})
export class DateTimePickerComponent {

  @Input()
  disabled = false;
  maxRange = (366 * 86400000);
  _startDate: Date = new Date();
  @Input()
  set startDate(val: Date) {
    this._startDate = val;
    let maxMillis = val.getTime() + this.maxRange;
    this.maxDate = new Date(maxMillis);
    if ( this.endDate.getTime() > maxMillis ) {
      this.endDate = new Date(maxMillis);
    }
    this.startDateChange.emit(val);
  }
  get startDate() {
    return this._startDate;
  }
  @Output() startDateChange: EventEmitter<Date> = new EventEmitter<Date>();

  _endDate: Date = new Date();
  @Input()
  set endDate(val: Date) {
    this._endDate = val;
    this.endDateChange.emit(val);
  }
  get endDate() {
    return this._endDate;
  }
  maxDate:Date;
  @Output()
  endDateChange: EventEmitter<Date> = new EventEmitter<Date>();
  bsConfig: Partial<BsDatepickerConfig>;

  constructor() {
    this.bsConfig = Object.assign({}, {
      containerClass: "theme-custom inline",
      showWeekNumbers: false,
      adaptivePosition: true,
      minMode: "day" as BsDatepickerViewMode
    });
  }
}
